import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Rating } from 'react-simple-star-rating'
import { monthDay } from '../../../utils/monthDay'
import { formatTimeRange } from '../../../utils/formattedTimeRange'
import { jobDetailsById, jobReviewRatingCreate } from '../../../redux/reducers/jobsSlice'
import { useDispatch, useSelector } from 'react-redux'

const Review = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { jobDetails } = useSelector((state) => state.jobs)
    const { user } = useSelector((state) => state.auth)
    let { id } = useParams();

    const [rating, setRating] = useState(0)
    const [review, setReview] = useState('')
    const [error, setError] = useState(false)
    const handleRating = (event) => {
        setRating(event)
    }


    const createReview = () => {
        let values = {
            rating: rating,
            review: review,
            staff: jobDetails?.assignTo.map(item => { return ({ "staff_id": item?.staff_id?._id }) }),
            customer: jobDetails?.customerUserId?._id,
            job: jobDetails?._id,
            order: jobDetails?.order_id?._id,
            date: new Date(),
        }
        if (!rating || !review) {
            setError(true)
        }
        else {
            setError(false)
            dispatch(jobReviewRatingCreate({ values, navigate }))
        }
    }

    useEffect(() => {
        if (id) {
            if (!user) {
                sessionStorage.setItem("reDirect_url", window.location.pathname)
                navigate('/login')
            }
            else {
                dispatch(jobDetailsById(id))

            }

        }

    }, [id])

    return (
        <div className={`review-main-div`}>
            <div>
                <p className={`give-us-review`}>Give Us Your Review</p>
            </div>
            <div>
                <img src='/assets/images/OHC-Logo.png' />
            </div>
            <div>
                <p>
                    Thank you for choosing One Heart Cleaning!<br />
                    Please give us a review for your recent job:
                </p>
            </div>
            <div>
                <p className={`job-title`}>{jobDetails?.order_id?.orderType} Cleaning</p>
                <p>Job {jobDetails?.jobId}, {monthDay(jobDetails?.startDate)} , {formatTimeRange(jobDetails?.startDate, jobDetails?.endDate)}</p>
            </div>
            <div className={`feedback-sec`}>
                <Rating
                    onClick={handleRating}
                    allowFraction
                /* Available Props */
                />
                {(error && !rating) && <p className={`error-text`}>Please add rating</p>}
                <div className='review-text-area'>
                    <textarea rows={6} cols={90} onChange={(e) => setReview(e.target.value)} />
                </div>
                {(error && !review) && <p className={`error-text`}>Please add review</p>}
            </div>
            <div>
                <button onClick={createReview}>Submit Review</button>
            </div>
        </div>
    )
}

export default Review